



































import Vue from "vue";
import Component from "vue-class-component";
import PageTitle from "@/components/atoms/PageTitle.vue";
import InputYearMonth from "@/components/molecules/InputYearMonth.vue";
import AlertMessage from "@/components/atoms/AlertMessage.vue";
import Utils from "@/common/utils";
import { LoginUserStore, OperationLogsStore } from "../store";
import { IAlertInfo, ITableOptions } from "@/types";
// eslint-disable-next-line @typescript-eslint/no-var-requires
const VueTabulator = require("vue-tabulator");
const Tabulator = VueTabulator.TabulatorComponent;
import moment from "moment-timezone";

interface ITableOperationLogs {
  timestamp: string;
  user_name: string;
  screen_name: string;
  operation_name: string;
}

@Component({
  components: { PageTitle, InputYearMonth, AlertMessage, Tabulator },
})
export default class OperationLogsCSV extends Vue {
  name: "OperationLogsCSV";
  private dangerAlertList: IAlertInfo[] = [];
  private targetYearMonth = "";
  private operationLogsTableList: ITableOperationLogs[] = [];

  get refs(): any {
    return this.$refs;
  }

  get title(): string {
    return "操作ログ";
  }

  get currentYearMonth(): string {
    const momentDate = moment().tz("Asia/Tokyo");
    const year = momentDate.format("YYYY");
    const month = momentDate.format("MM");
    return year + month;
  }

  get yearFrom(): number {
    return 2011;
    // return 2021;
  }

  get yearTo(): number {
    return Number(this.currentYearMonth.substr(0, 4));
  }

  created() {
    this.targetYearMonth = this.currentYearMonth;
  }

  private downloadCSV() {
    const tabulator: any = this.refs.operationLogsTabulator;
    const tabulatorInstance = tabulator.getInstance();
    const self = this;
    const fileFormatter = function (
      list: any[],
      options: any,
      setFileContents: any
    ) {
      let delimiter = options && options.delimiter ? options.delimiter : ",";
      let fileContents: string[] = [];
      let headers: string[] = [];

      list.forEach(function (row) {
        let item: string[] = [];

        switch (row.type) {
          case "group":
            console.warn(
              "Download Warning - CSV downloader cannot process row groups"
            );
            break;

          case "calc":
            console.warn(
              "Download Warning - CSV downloader cannot process column calculations"
            );
            break;

          case "header":
            row.columns.forEach(function (col: any, i: number) {
              if (col && col.depth === 1) {
                headers[i] =
                  typeof col.value == "undefined" || col.value === null
                    ? ""
                    : '"' + String(col.value).split('"').join('""') + '"';
              }
            });
            break;

          case "row":
            row.columns.forEach(function (col: any) {
              if (col) {
                switch (typeof col.value) {
                  case "object":
                    col.value = JSON.stringify(col.value);
                    break;

                  case "undefined":
                    col.value = "";
                    break;
                  default:
                    if (col.value === null) {
                      col.value = "";
                      break;
                    }
                }

                item.push('"' + String(col.value).split('"').join('""') + '"');
              }
            });

            fileContents.push(item.join(delimiter));
            break;
        }
      });

      if (headers.length) {
        fileContents.unshift(headers.join(delimiter));
      }

      let fileContentsToString = fileContents.join("\r\n");

      if (options.bom) {
        fileContentsToString = "\uFEFF" + fileContentsToString;
      }

      setFileContents(fileContentsToString, "text/csv");
    };

    const fileName = `操作ログCSV_${self.currentYearMonth}.csv`;
    // CSVダウンロード
    tabulatorInstance.download(fileFormatter, fileName, {
      bom: true,
    });
  }

  private async onClickDownloadOperationLogsButton(): Promise<void> {
    try {
      Utils.showTransparentLoadingModal(this.$bvModal);
      this.clearAlertList();

      await OperationLogsStore.fetchOperationLogs({
        user_id: LoginUserStore.getLoginUser.user_id,
        target_year_month: this.targetYearMonth,
      });
      this.operationLogsTableList = OperationLogsStore.getOperationLogs;

      setTimeout(this.downloadCSV, 100);
    } catch (errorInfos) {
      if (errorInfos) {
        if (Array.isArray(errorInfos)) {
          errorInfos.forEach((error: any) => {
            if (error.item && error.message) {
              this.dangerAlertList.push({
                item: error.item,
                message: error.message,
              });
            }
          });
        }
      }
      if (this.dangerAlertList.length == 0) {
        this.dangerAlertList.push(Utils.getCommonAlertInfo());
      }
    } finally {
      Utils.hideTransparentLoadingModal(this.$bvModal);
    }
  }

  get tableOptions(): ITableOptions {
    return {
      layout: "fitDataStretch",
      pagination: "local",
      paginationSize: 1,
      columns: [
        {
          title: "操作日時",
          field: "timestamp",
          sorter: "string",
        },
        {
          title: "操作者",
          field: "user_name",
          sorter: "string",
        },
        {
          title: "操作画面",
          field: "screen_name",
          sorter: "string",
        },
        {
          title: "利用機能種別",
          field: "operation_name",
          sorter: "string",
        },
      ],
    };
  }

  private clearAlertList(): void {
    this.dangerAlertList = [];
  }
}
